import CivilClusterPage from "./seo/CivilClusterPage";

export default function SafetyManagementNZ() {
  return <CivilClusterPage pageKey="safety" />;
}
